import React from "react";
import { faClose, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { useState } from "react";
import TextareaAutosize from 'react-textarea-autosize';
import { getChatReply } from "../../_helpers/process-chat";

export const ChatWindow = ({visible, show, handleInput, message}) => {

    const msg = "Hello, welcome to Universal Educational Services and  Travels services chat assistant. Can you please tell us how we can be of help?";


    const [openMesg, setOpenMesg] = useState(false);
    const [sysType, setSysType] = useState('');
    const [chatMessages, setChatMessages] = useState([]);
    const [userMessage,setUserMessage] = useState('');
    

    const openChat = () => { 
        setOpenMesg(true);
        typeMessage();
    }

    const handleSendMessage = (msg) =>{
        setChatMessages((messages) => ([...messages, {
            sender: "user",
            textContent: msg
        }]));
        setUserMessage('');
        sendResponse(msg);
    }

    const sendResponse = (userMessage) => {
        let reply = getChatReply(userMessage);
        
        setChatMessages((messages) => ([...messages, {
            sender: "bot",
            textContent: reply[0].message,
            replies: reply
        }]));
    }


    const typeMessage = () => {
        let msgs = ''
        for (let i = 0; i < msg.length; i++) {
            setTimeout(() => {
                setSysType((t) => t+msg[i])
               return msgs
            }, i * 50);
        }
    };

    return (
        <div className={classNames("chat-window", {"unwrapped": visible})}>
            <div className="chat-close-box">
                <button 
                    className={classNames("tr-btn", "ttl")}
                    onClick={show} 
                >
                    <FontAwesomeIcon icon={faClose} color="#efefef" />
                </button>
            </div>
            <div className="chat-scroll">
            {openMesg === false ?
            <div className="chat-welcome">
                <div className="greetings-msg">
                    <p><span>Hello</span> 👋</p>
                    <p>How can we help you?</p>
                </div>
                <button className="chat-input-box" onClick={openChat}>
                    <span className="hs-4">Send us a message</span>
                    <FontAwesomeIcon icon={faPaperPlane} color="#2c4ecb" />
                </button>
                <div className={classNames("chat-scroll-box")}>
                    <div className={classNames("chat-suggestions")}>
                        <button className={classNames('sug-btn')}>
                            How can I get a student Visa for Canada?
                        </button>
                        <button className={classNames('sug-btn')}>
                            I wish to reserve a flight
                        </button>
                        <button className={classNames('sug-btn')}>
                            What are the requirements to study in Singapore?
                        </button>
                    </div>
                
                </div>
            </div>:(
            <div className="chat-box">
                <div className="message-section">
                    <div className="sy-box">
                    <div 
                        className={
                            classNames(
                                "message-output",
                                {"sys-msg": true },
                                {"user-mesg": false}
                            )
                        }
                    >
                        {sysType}
                    </div>
                    </div>
                    {chatMessages.map((mesg) => {
                        return (
                            <div className={classNames(
                                {'sys-box': mesg.sender === 'bot'},
                                {"user-box": mesg.sender === "user"}
                            )}>
                                <div 
                                    className={
                                        classNames(
                                            "message-output",
                                            {"sys-msg": mesg.sender === 'bot' },
                                            {"user-msg": mesg.sender === 'user'}
                                        )
                                    }
                                >
                                    { mesg.textContent }
                                    {mesg.replies?.map((reply) => {
                                        return (
                                            <div>
                                                {reply?.url &&( 
                                                    <a href={reply?.url}>{reply?.url?.slice(1)}</a>
                                                )}
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="chat-input">
                    <TextareaAutosize 
                       style={{
                            flexGrow: 1,
                            height: 40, 
                            outline: "#2c4ecb"
                        }}
                       minRows={2}
                       value={userMessage}
                       onChange={(e) => setUserMessage(e.target.value)}
                    />
                    <button className="chat-send" onClick={() => handleSendMessage(userMessage)}>
                        <FontAwesomeIcon icon={faPaperPlane} color="#2c4ecb" />
                    </button>
                </div>
                
            </div>
            )}
            </div>
        </div>
    )
}